import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Header from '../Utility/Components/Header'
import Footer from '../Utility/Components/Footer'
import Left from '../Utility/Components/Left'
import { logOutApp } from '../GlobalModules/Login/Actions/LoginAction';
import NotFoundPage from '../Utility/Pages/NotFound';
import FAB from '../../src/Utility/Components/FAB'
import { Link, useParams, withRouter } from 'react-router-dom';
import { FaPlus, FaBed, FaFileAlt } from 'react-icons/fa';
import Utility from '../../src/Utility/Utility';

const AuthLayout = (props) => {
  const { userCredentials, logOutApp, history, allowedRoles } = props;
  const [showNotFound, setShowNotFound] = useState(false);
  const bookingPermissions = Utility.hasMultipleActionPermissions(
    'booking_room',
    null,
    ['create'],
    props.userCredentials?.user_details?.user_type
  );
  const quotationPermissions = Utility.hasMultipleActionPermissions(
    'quotation',
    null,
    ['create'],
    props.userCredentials?.user_details?.user_type
  );
  //initially check user credentials are valid or not
  useEffect(() => {
    checkForUSerCrendentials()
  }, []);

  //user credentials checking and redirection fn
  const checkForUSerCrendentials = () => {
    if (props.token == undefined || props.token == "") {
      history.push("/")
    }
    if (!props.token || props.token === "" || !allowedRoles.includes(userCredentials?.user_details?.user_type)) {
      const timer = setTimeout(() => {
        setShowNotFound(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  }

  const handleClick = (type,modalType) => {
      history.push({
          pathname: `/en/home/${type}`,
          search: `?openModal=${modalType}`,
          state: {
            prefilledData: null
          }
        });
  };

  let userType = ['agent', 'agent_staff', 'app_admin', 'revenue_manager', 'revenue_staff']

  return (
    <>
      {props.token && props.token !== "" && allowedRoles.includes(userCredentials?.user_details?.user_type) ?
        <div className="page_customize">
          <div className={`pagecontainer ${props.leftbar ? "overlayBackground" : " "}`}>
            <Header history={props.history} />
            <Left history={props.history} />
            {/* className={props.leftbar ? 'content_open' : 'content_closed'} */}
            <div className={'content_closed'} style={{ minHeight: '91vh', backgroundColor: 'rgb(248, 248, 248)', paddingTop: '0px', transition: 'padding .3s ease-in-out', display: 'flex', borderRadius: '0px 0px 15px 65px' }}>
              {props.children}
            </div>
            {userCredentials?.user_details ? <Footer /> : null}
          </div>
        </div>
        :
        showNotFound && <NotFoundPage permission={false} history={props.history} />
      }
      {!userType.includes(userCredentials.user_details?.user_type)  && (bookingPermissions?.create || quotationPermissions?.create)?
        <FAB
          icon={FaPlus}
          tooltip="Quick Actions"
          color="primary"
          position="bottom-right"
          direction="up"
          draggable={true}
          options={[
            {
              component: <Link to={`/en/home/booking_room?openModal=newBooking`} />,
              onClick: () => handleClick("booking_room","newBooking"),
              icon: FaBed,
              tooltip: 'New Booking',
              color: 'success',
              isVisible: Object.keys(Utility.getRoleObjectByEventKey('booking_room')).length > 0 && (Utility.getRoleObjectByEventKey('booking_room').rules == "CRUD" || Utility.getRoleObjectByEventKey('booking_room').rules == "CUD") && bookingPermissions?.create
            },
            {
              component: <Link to={`/en/home/quotation?openModal=newQuotation`} />,
              onClick: () => handleClick("quotation","newQuotation"),
              icon: FaFileAlt,
              tooltip: 'New Quotation',
              color: 'primary',
              isVisible: Object.keys(Utility.getRoleObjectByEventKey('quotation')).length > 0 && (Utility.getRoleObjectByEventKey('quotation').rules == "CRUD" || Utility.getRoleObjectByEventKey('quotation').rules == "CUD") && quotationPermissions?.create
            }
          ]}
        /> : null}
    </>
  );

}


const mapStateToProps = (globalState) => {
  return {
    leftbar: globalState.mainReducerData.leftbar,
    userCredentials: globalState.LoginReducer.userCredentials,
    token: globalState.LoginReducer.token,
  };

}

export default connect(mapStateToProps, { logOutApp })(AuthLayout);